var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDoc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.083 1.66602H5.33301C4.22844 1.66602 3.33301 2.56145 3.33301 3.66601V16.3327C3.33301 17.4373 4.22844 18.3327 5.33301 18.3327H14.6663C15.7709 18.3327 16.6663 17.4373 16.6663 16.3327V6.24935M12.083 1.66602L16.6663 6.24935M12.083 1.66602V4.24935C12.083 5.35392 12.9784 6.24935 14.083 6.24935H16.6663",
    stroke: "#3C6FF5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57221 9.16602C9.40292 9.16602 9.30134 9.24038 9.26748 9.38084L8.61571 11.8431L8.28559 13.2807H8.26019L7.93854 11.8513L7.32062 9.3891C7.28676 9.24038 7.18518 9.16602 7.02436 9.16602H6.03399C5.95781 9.16602 5.89856 9.1908 5.8647 9.24038C5.83084 9.29822 5.82238 9.36432 5.84777 9.4552L7.35448 14.7763C7.3968 14.925 7.49838 14.9993 7.6592 14.9993H8.70882C8.86965 14.9993 8.97122 14.925 9.01354 14.7763L9.69072 12.4214L9.98698 11.2316H10.0124L10.3086 12.4214L10.9858 14.7763C11.0281 14.925 11.1297 14.9993 11.2905 14.9993H12.3486C12.5094 14.9993 12.611 14.925 12.6533 14.7763L14.1516 9.4552C14.177 9.36432 14.1685 9.29822 14.1346 9.24038C14.1008 9.1908 14.0415 9.16602 13.9654 9.16602H12.975C12.8142 9.16602 12.7126 9.24038 12.6787 9.3891L12.0608 11.8513L11.7476 13.2807H11.7138L11.3836 11.8431L10.7319 9.38084C10.698 9.24038 10.5964 9.16602 10.4271 9.16602H9.57221Z",
    fill: "#3C6FF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_doc.fcbeefde8f435f96a0a61efabb68891a.svg";